import React, { useReducer } from 'react'
import ReturnReducer from './returnReducer'
import ReturnContext from './returnContext'
import { apiCall } from '@/product/common/api'
import { response } from '@/product/context/common'

import {
    CLEAR_RESPONSE,
    RESPONSE_STATUS,
    GET_SINGLE_REQUEST,
    GET_USER_REQUEST_COUNT,
} from './returnTypes'

const ReturnState = (props) => {
    const initialState = {
        single_request: null,
        user_request_count: null,
        responseStatus: null,
    }

    const [state, dispatch] = useReducer(ReturnReducer, initialState)
    let resp = new response(dispatch, RESPONSE_STATUS)

    const getSingleRequest = async (formData, fromVariable) => {
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'return/getSingleRequest',
                    formData,
                    '',
                    'admin',
                    '',
                    true
                ),
            ])
            const from = fromVariable ? fromVariable : 'getSingleRequest'
            if (res.data.status === 'success') {
                console.log(
                    res.data.data.responseData,
                    'res.data.data.responseData.records'
                )
                dispatch({
                    type: GET_SINGLE_REQUEST,
                    payload: {
                        records: res.data.data.responseData.data
                            ? res.data.data.responseData.data
                            : [],

                        from: from,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getUserRequestCount = async (formData, fromVariable) => {
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'return/getUserRequestCount',
                    formData,
                    '',
                    'admin',
                    '',
                    true
                ),
            ])
            const from = fromVariable ? fromVariable : 'getUserRequestCount'
            if (res.data.status === 'success') {
                console.log(
                    res.data.data.responseData,
                    'res.data.data.responseData.records'
                )
                dispatch({
                    type: GET_USER_REQUEST_COUNT,
                    payload: {
                        records: res.data.data.responseData.data
                            ? res.data.data.responseData.data
                            : [],

                        from: from,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const updateRequest = async (formData, fromVariable) => {
        try {
            const from = fromVariable ? fromVariable : 'updateRequest'
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'return/refundRequest',
                    formData,
                    '',
                    'admin',
                    '',
                    true
                ),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const clearResponse = () =>
        dispatch({
            type: CLEAR_RESPONSE,
        })

    return (
        <ReturnContext.Provider
            value={{
                responseStatus: state.responseStatus,
                single_request: state.single_request,
                user_request_count: state.user_request_count,
                getSingleRequest,
                getUserRequestCount,
                updateRequest,
                clearResponse,
            }}
        >
            {props.children}
        </ReturnContext.Provider>
    )
}

export default ReturnState
